document.addEventListener('DOMContentLoaded', function () {
    (function () {
        const CARD_OPEN_CLASS = 'is-expanded';
        const openedMap = new WeakMap();

        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.find_more');
            if (!btn) return;

            // blocca l'overlay link della card (Horizon)
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // card prodotto
            const card = btn.closest('product-card, .product-card, li.product-grid__item');
            if (!card) return;

            // Inizializza attributi ARIA al primo click se non presenti
            if (!btn.hasAttribute('aria-expanded')) {
                btn.setAttribute('aria-expanded', 'false');
                btn.setAttribute('role', 'button');
                
                // Aggiungi label descrittivo se non presente
                if (!btn.hasAttribute('aria-label') && !btn.textContent.trim()) {
                    btn.setAttribute('aria-label', 'Mostra più informazioni sul prodotto');
                }
            }

            // Crea o trova il contenitore dei contenuti espandibili
            let expandableContent = card.querySelector('[data-expandable-content]');
            if (!expandableContent) {
                // Trova tutti gli elementi .hide e wrappali (opzionale, per migliore semantica)
                const hideElements = card.querySelectorAll('.hide');
                if (hideElements.length > 0) {
                    // Genera ID univoco per collegare button e region
                    const contentId = 'expandable-' + Math.random().toString(36).substr(2, 9);
                    btn.setAttribute('aria-controls', contentId);
                    
                    // Aggiungi attributi al primo elemento nascosto come riferimento
                    hideElements[0].setAttribute('data-expandable-content', '');
                    hideElements[0].setAttribute('id', contentId);
                    hideElements[0].setAttribute('role', 'region');
                    hideElements[0].setAttribute('aria-label', 'Informazioni aggiuntive prodotto');
                }
            }

            // toggle stato card
            const nowOpen = !card.classList.contains(CARD_OPEN_CLASS);
            card.classList.toggle(CARD_OPEN_CLASS, nowOpen);

            if (nowOpen) {
                // APRI: memorizza gli elementi .hide e rimuovi la classe
                const toReveal = card.querySelectorAll('.hide');
                openedMap.set(card, toReveal);
                toReveal.forEach(el => {
                    el.classList.remove('hide');
                    // Rimuovi aria-hidden quando mostri il contenuto
                    el.removeAttribute('aria-hidden');
                });
                btn.setAttribute('aria-expanded', 'true');
                btn.classList.add('is-open');
                
                // Aggiorna label se presente
                const currentLabel = btn.getAttribute('aria-label');
                if (currentLabel && currentLabel.includes('Mostra')) {
                    btn.setAttribute('aria-label', currentLabel.replace('Mostra', 'Nascondi'));
                }
                
                // Opzionale: sposta focus sul primo elemento interattivo rivelato
                // const firstInteractive = Array.from(toReveal).find(el => 
                //     el.matches('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                // );
                // if (firstInteractive) firstInteractive.focus();
                
            } else {
                // CHIUDI: ri-applica .hide SOLO a quelli che erano nascosti all'apertura
                const toRehide = openedMap.get(card);
                if (toRehide) {
                    toRehide.forEach(el => {
                        if (!el.classList.contains('hide')) {
                            el.classList.add('hide');
                            // Aggiungi aria-hidden quando nascondi il contenuto
                            el.setAttribute('aria-hidden', 'true');
                        }
                    });
                    openedMap.delete(card);
                }
                btn.setAttribute('aria-expanded', 'false');
                btn.classList.remove('is-open');
                
                // Ripristina label
                const currentLabel = btn.getAttribute('aria-label');
                if (currentLabel && currentLabel.includes('Nascondi')) {
                    btn.setAttribute('aria-label', currentLabel.replace('Nascondi', 'Mostra'));
                }
            }
        }, true); // cattura per battere l'overlay link

        // Supporto tastiera: permetti apertura/chiusura con Enter e Space
        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            
            const btn = e.target.closest('.find_more');
            if (!btn) return;

            e.preventDefault();
            btn.click(); // Riusa la logica del click
        }, true);

    })();

    /* Pagina test */
    (function () {
        const testPage = document.querySelector('main[data-template="page.test"]');
        if (!testPage) return; // esci se non è la pagina del test

        const questions = testPage.querySelectorAll("#question");
        const nextBtns = testPage.querySelectorAll(".test_next");
        const prevBtns = testPage.querySelectorAll(".test_prev");
        const showResultsBtn = testPage.querySelector(".show_results");
        const sectionsToHide = testPage.querySelectorAll("#section_to_hide");
        const resultBackBtns = testPage.querySelectorAll(".result_back");

        const results = {
            first_solution: testPage.querySelector("#first_solution"),
            second_solution: testPage.querySelector("#second_solution"),
            third_solution: testPage.querySelector("#third_solution"),
            fourth_solution: testPage.querySelector("#fourth_solution"),
            fifth_solution: testPage.querySelector("#fifth_solution"),
            sixth_solution: testPage.querySelector("#sixth_solution"),
        };

        let currentQuestion = 0;
        let answers = [];

        // inizializza: nasconde tutte le section_to_hide
        sectionsToHide.forEach(s => (s.style.display = "none"));

        function showQuestion(index) {
            questions.forEach((q, i) => {
                q.style.display = i === index ? "grid" : "none";
            });

            // disabilita il pulsante avanti o mostra risultati se non è stata data risposta
            const nextBtn = questions[index].querySelector(".test_next");
            const showBtn = questions[index].querySelector(".show_results");

            if (!answers[index]) {
                if (nextBtn) nextBtn.classList.add("is-disabled");
                if (showBtn) showBtn.classList.add("is-disabled");
            } else {
                if (nextBtn) nextBtn.classList.remove("is-disabled");
                if (showBtn) showBtn.classList.remove("is-disabled");
            }
        }

        // Gestione selezione risposte + ACCESSIBILITÀ
        testPage.querySelectorAll(".answer").forEach(answer => {
            // 👉 Accessibilità tastiera: tab + ruolo pulsante
            answer.setAttribute("tabindex", "0");
            answer.setAttribute("role", "button");

            // Click con mouse / touch
            answer.addEventListener("click", () => {
                const questionEl = answer.closest("#question");
                const allAnswers = questionEl.querySelectorAll(".answer");
                allAnswers.forEach(a => a.classList.remove("active"));
                answer.classList.add("active");

                const questionIndex = [...questions].indexOf(questionEl);
                if (answer.classList.contains("answer_1")) answers[questionIndex] = "a";
                if (answer.classList.contains("answer_2")) answers[questionIndex] = "b";
                if (answer.classList.contains("answer_3")) answers[questionIndex] = "c";

                // sblocca il bottone avanti o mostra risultati quando è stata scelta una risposta
                const nextBtn = questionEl.querySelector(".test_next");
                const showBtn = questionEl.querySelector(".show_results");
                if (nextBtn) nextBtn.classList.remove("is-disabled");
                if (showBtn) showBtn.classList.remove("is-disabled");
            });

            // Attivazione con tastiera (Invio o Space)
            answer.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    answer.click(); // riusa la stessa logica del click
                }
            });
        });

        // Navigazione avanti
        nextBtns.forEach(btn => {
            btn.addEventListener("click", e => {
                if (btn.classList.contains("is-disabled")) {
                    e.preventDefault();
                    return;
                }
                if (currentQuestion < questions.length - 1) {
                    currentQuestion++;
                    showQuestion(currentQuestion);
                }
            });
        });

        // Navigazione indietro
        prevBtns.forEach(btn => {
            btn.addEventListener("click", e => {
                if (currentQuestion > 0) {
                    e.preventDefault();
                    currentQuestion--;
                    showQuestion(currentQuestion);
                }
            });
        });

        // Mostra risultati
        if (showResultsBtn) {
            showResultsBtn.addEventListener("click", e => {
                if (showResultsBtn.classList.contains("is-disabled")) {
                    e.preventDefault();
                    return;
                }

                // Nasconde tutte le domande
                questions.forEach(q => (q.style.display = "none"));

                const countA = answers.filter(a => a === "a").length;
                const countB = answers.filter(a => a === "b").length;
                const countC = answers.filter(a => a === "c").length;

                // Nasconde tutte le soluzioni
                Object.values(results).forEach(r => r && (r.style.display = "none"));

                let resultToShow = null;

                if (countA > countB && countA > countC) resultToShow = results.first_solution;
                else if (countB > countA && countB > countC) resultToShow = results.second_solution;
                else if (countC > countA && countC > countB) resultToShow = results.third_solution;
                else if (countA === countC && countA > countB) resultToShow = results.fourth_solution;
                else if (countA === countB && countA > countC) resultToShow = results.fifth_solution;
                else if (countB === countC && countB > countA) resultToShow = results.sixth_solution;
                else resultToShow = results.second_solution;

                // Mostra risultato + sezioni aggiuntive
                if (resultToShow) {
                    resultToShow.style.display = "grid";
                    resultToShow.scrollIntoView({ behavior: "smooth" });
                    sectionsToHide.forEach(s => (s.style.display = "grid"));
                }
            });
        }

        // 🔙 Gestione "torna indietro" dalla pagina risultati
        resultBackBtns.forEach(btn => {
            btn.addEventListener("click", e => {
                e.preventDefault();

                // nascondi tutte le soluzioni e sezioni extra
                Object.values(results).forEach(r => r && (r.style.display = "none"));
                sectionsToHide.forEach(s => (s.style.display = "none"));

                // mostra l'ultima domanda (l’ultima del quiz)
                currentQuestion = questions.length - 1;
                showQuestion(currentQuestion);

                // scrolla su di essa
                questions[currentQuestion].scrollIntoView({ behavior: "smooth" });
            });
        });

        // Inizializza
        showQuestion(currentQuestion);
    })();

    // Script per nascondere i button che rimandano alla collezione corrente
    (function() {
        'use strict';
        
        function getCurrentCollectionHandle() {
            const path = window.location.pathname;
            const collectionMatch = path.match(/\/collections\/([^\/]+)/);
            
            if (collectionMatch && collectionMatch[1]) {
            return collectionMatch[1];
            }
            
            return null;
        }
        
        function hideCollectionButtons() {
            const currentCollection = getCurrentCollectionHandle();
            
            if (!currentCollection) {
            return;
            }
        
            const buttons = document.querySelectorAll('.navbar_buttons a[href*="/collections/"]');
            
            buttons.forEach(button => {
            const href = button.getAttribute('href');
            
            if (href && href.includes(`/collections/${currentCollection}`)) {
                button.style.display = 'none';
            }
            });
        }
        
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', hideCollectionButtons);
        } else {
            hideCollectionButtons();
        }
        
        setTimeout(hideCollectionButtons, 500);     
    })();

    /* Chiusura menu al click su link con ancora */
    (function () {
        const headerDrawer = document.querySelector('header-drawer');
        if (!headerDrawer) return;

        // Seleziona tutti i link del menu che contengono un'ancora
        const menuLinks = headerDrawer.querySelectorAll('a[href*="#"]');

        menuLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                
                // Verifica se è un link con ancora (inizia con # o contiene #)
                if (href && href.includes('#')) {
                    // Chiama il metodo close del custom element header-drawer
                    setTimeout(() => {
                        if (headerDrawer.isOpen) {
                            headerDrawer.close();
                        }
                    }, 100);
                }
            });
        });
    })();

});